























import { Vue, Component, Prop } from "vue-property-decorator";

// Types
import { IUploadFile } from "@/models/uploadFiles";

@Component
export default class FileUploadButton extends Vue {
  // Refs

  public $refs!: {
    uploadFileField: HTMLFormElement;
  };

  // Props
  @Prop({ required: true })
  public value!: IUploadFile[];

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: false })
  public initialOpen!: boolean;

  @Prop({ default: undefined })
  public accepts!: string;

  // Data
  public get files() {
    return this.value;
  }

  public set files(value) {
    this.$emit("input", value);
  }

  public created() {
    if (this.initialOpen) {
      this.$nextTick(() => {
        this.$refs.uploadFileField.$el.click();
      });
    }
  }
}
